import React, { useState } from 'react'

import useFilter from 'hooks/useFilter'
import useFetch from 'hooks/useFetch'
import usePagination from 'hooks/usePagination'

import {
  Button,
  Container,
  Box,
  Grid,
  Card,
  TablePagination,
  useMediaQuery,
} from '@material-ui/core'
import { useTheme } from '@material-ui/styles'
import { Skeleton } from '@material-ui/lab'

import { Page, ContentHeader, FilterButton, Filters } from 'components'
import DomainsTable from './components/DomainsTable'
import DialogDomain from './components/DialogDomain'

import * as service from 'service'

const DomainsMain = () => {
  const [dialogDomain, setDialogDomain] = useState(false)
  const filter = useFilter()
  const theme = useTheme()
  const isDesktop = useMediaQuery(theme.breakpoints.up('sm'), {
    defaultMatches: true,
  })
  const {
    perPage,
    page,
    handleChangePage,
    handleChangeRowsPerPage,
  } = usePagination(10)

  const { response, isLoading, refresh } = useFetch(
    service.cookie.websites.get,
    {
      perPage,
      page,
      ...{ ...filter.filters },
    },
    [page, perPage, filter.filters],
  )

  return (
    <Page title="Todos os domínios">
      <Container maxWidth={false}>
        <ContentHeader menu="Sistema" title="Cookies" subtitle="Domínios">
          <Box pl={1} display="flex">
            <Button
              variant="contained"
              color="primary"
              onClick={() => setDialogDomain(true)}
            >
              Novo
            </Button>
            <Box ml={1}>
              <FilterButton setDrawerOpen={filter.setDrawerOpen} />
            </Box>
          </Box>
        </ContentHeader>
        <Card>
          <Box display="flex" width="100%" mt={2}>
            <Grid container>
              <DomainsTable
                domains={response?.data.websites}
                isLoading={isLoading}
                onEvent={refresh}
              />
            </Grid>
          </Box>
          {response?.data?.meta && (
            <Box px={2} display="flex" justifyContent="flex-end">
              {!isLoading && response ? (
                <TablePagination
                  component="div"
                  count={response?.data?.meta?.totalCount}
                  onChangePage={handleChangePage}
                  onChangeRowsPerPage={handleChangeRowsPerPage}
                  page={page - 1}
                  rowsPerPage={perPage}
                  rowsPerPageOptions={[5, 10, 25, 100]}
                  labelRowsPerPage={isDesktop ? 'Por página' : ''}
                  nextIconButtonProps={{ size: 'small' }}
                  backIconButtonProps={{ size: 'small' }}
                />
              ) : (
                <Box py="11px">
                  <Skeleton variant="rect" width={200} height={30} />
                </Box>
              )}
            </Box>
          )}
        </Card>
        <Filters filter={filter}>
          <input textfieldinput="true" label="Domínio" name="domain" />
          <select textfieldinput="true" label="Confirmado" name="confirmed">
            <option value=""></option>
            <option value={true}>Sim</option>
            <option value={false}>Não</option>
          </select>
        </Filters>
      </Container>
      <DialogDomain
        open={dialogDomain}
        setOpen={setDialogDomain}
        onEvent={refresh}
      />
    </Page>
  )
}

export default DomainsMain
